import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './theme/header/header.component';
import { FooterComponent } from './theme/footer/footer.component';
import { ErrorMessageComponent } from './theme/error-message/error-message.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDateParserFormatter, NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { JobFilterComponent } from './shared/job-filter/job-filter.component';
import { FilterListComponent } from './shared/filter-list/filter-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaginationComponent } from './shared/pagination/pagination.component';
import { TruncatePipe } from './pipes/truncate/truncate.pipe';
import { SpecialCharacterDirective } from './directives/special-chars/special-character.directive';
import { UpperCaseDirective } from './directives/upper-case.directive';
import { SafeHtmlPipe } from './pipes/safeHtml/safe-html.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { AppsPipePipe } from './pipes/apps-pipe.pipe';
import { ReasonPipe } from './pipes/reason.pipe';
import { CaptchaComponent } from './shared/captcha/captcha.component';
import { PasswordValidationComponent } from './shared/password-validation/password-validation.component';
import { ValidationService } from './services/validation.service';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FooterCenterComponent } from './theme/footer-center/footer-center.component';
import { NapsButtonComponent } from './theme/naps-button/naps-button.component';
import { HamburgerMenuComponent } from './theme/hamburger-menu/hamburger-menu.component';
import { OverlayModule } from '@angular/cdk/overlay';


import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

import { AutocompleteSearchComponent } from './shared/components/autocomplete-search/autocomplete-search.component';
import { SelectDropdownComponent } from './shared/components/select-dropdown/select-dropdown.component';
import { SliderRangeComponent } from './shared/components/slider-range/slider-range.component';
import { ShortNumberPipe } from './pipes/short-number.pipe';
import { RadioButtonComponent } from './shared/components/radio-button/radio-button.component';
import { CustomRightPanelHeadingComponent } from './shared/components/custom-right-panel-heading/custom-right-panel-heading.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import { NsdcInputBoxComponent } from './shared/reskinning/nsdc-input-box/nsdc-input-box.component';
import { NsdcSelectBoxComponent } from './shared/reskinning/nsdc-select-box/nsdc-select-box.component';
import { NapsFilePickerComponent } from './shared/reskinning/naps-file-picker/naps-file-picker.component';
import { NapsDatePickerComponent } from './shared/reskinning/naps-date-picker/naps-date-picker.component';
import { NapsActionButtonsComponent } from './shared/naps-action-buttons/naps-action-buttons.component';
import { NapsBgWrapperComponent } from './shared/naps-bg-wrapper/naps-bg-wrapper.component';
import { NapsDividerComponent } from './shared/naps-divider/naps-divider.component';
import { NapsEditButtonComponent } from './shared/naps-edit-button/naps-edit-button.component';
import { NapsGoBackBreadcrumbComponent } from './shared/naps-go-back-breadcrumb/naps-go-back-breadcrumb.component';
import { NapsViewButtonComponent } from './shared/naps-view-button/naps-view-button.component';
import { NapsProgressBarComponent } from './shared/naps-progress-bar/naps-progress-bar.component';
// import { ScrollSpyDirective } from '../../directives/scroll-spy.directive';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgbDateCustomParserFormatterService } from './shared/services/ngb-datepicker.service';
import { ShareStoryPromptComponent } from './shared/share-story-prompt/share-story-prompt.component';
import { ExternalLinkGuardDirective } from './directives/external-link-guard/external-link-guard.directive';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    SlickCarouselModule,
    ToastrModule.forRoot(),
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    AutocompleteSearchComponent,
    SelectDropdownComponent,
    SliderRangeComponent,
    OverlayModule,
    RadioButtonComponent,
    CustomRightPanelHeadingComponent,
    NgbTooltipModule,
    MatMenuModule,
    MatCardModule,
    MatDividerModule,
    NsdcInputBoxComponent,
    NsdcSelectBoxComponent,
    NapsDatePickerComponent,
    NapsFilePickerComponent,
    ScrollingModule
  ],
  declarations: [
    FooterCenterComponent,
    HeaderComponent,
    FooterComponent,
    NapsButtonComponent,
    HamburgerMenuComponent,
    // ScrollSpyDirective,
    SpecialCharacterDirective,
    UpperCaseDirective,
    JobFilterComponent,
    FilterListComponent,
    PaginationComponent,
    ErrorMessageComponent,
    CaptchaComponent,
    TruncatePipe,
    SafeHtmlPipe,
    FormatDatePipe,
    AppsPipePipe,
    ReasonPipe,
    ShortNumberPipe,
    PasswordValidationComponent,
    NapsActionButtonsComponent,
    NapsBgWrapperComponent,
    NapsDividerComponent,
    NapsEditButtonComponent,
    NapsGoBackBreadcrumbComponent,
    NapsViewButtonComponent,
    NapsProgressBarComponent,
    ShareStoryPromptComponent,
    ExternalLinkGuardDirective
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    SlickCarouselModule,
    HeaderComponent,
    PaginationComponent,
    JobFilterComponent,
    FilterListComponent,
    FooterComponent,
    ErrorMessageComponent,
    CaptchaComponent,
    ToastrModule,
    TruncatePipe,
    SafeHtmlPipe,
    FormatDatePipe,
    SpecialCharacterDirective,
    UpperCaseDirective,
    AppsPipePipe,
    ReasonPipe,
    ShortNumberPipe,
    PasswordValidationComponent,
    CustomRightPanelHeadingComponent,
    NapsButtonComponent,
    NgbTooltipModule,
    MatMenuModule,
    MatCardModule,
    MatDividerModule,
    NsdcInputBoxComponent,
    NsdcSelectBoxComponent,
    NapsFilePickerComponent,
    NapsDatePickerComponent,
    NapsActionButtonsComponent,
    NapsBgWrapperComponent,
    NapsDividerComponent,
    NapsEditButtonComponent,
    NapsGoBackBreadcrumbComponent,
    NapsViewButtonComponent,
    NapsProgressBarComponent,
    RadioButtonComponent,
    ScrollingModule,
    ExternalLinkGuardDirective
  ],providers:[
    ValidationService,
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatterService },
    ]
})
export class SharedModule { }
